var map = {
	"./1.png": 1320,
	"./10.png": 758,
	"./11.png": 757,
	"./12.png": 762,
	"./13.png": 1321,
	"./14.png": 756,
	"./15.png": 1322,
	"./16.png": 1323,
	"./17.png": 761,
	"./18.png": 760,
	"./19.png": 759,
	"./2.png": 1324,
	"./20.png": 755,
	"./21.png": 1325,
	"./22.png": 1326,
	"./23.png": 1327,
	"./3.png": 1328,
	"./4.png": 1329,
	"./5.png": 753,
	"./6.png": 751,
	"./7.png": 752,
	"./8.png": 754,
	"./9.png": 1330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1319;